import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation';

import WatchlistTopicsToolip from '../WatchlistTopicsTooltip';
import Tooltip from '../../Tooltip';

import * as watchlistActions from '../../../actions/watchlistActions';
import * as searchActions from '../../../actions/searchActions';

import useSizes from '../../../hooks/sizes';

import {
  queryItemWatchlistParser,
  parseQueryLogicalStructure,
} from '../../../helpers/watchlistHelperFunctions';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const tooltipContentStyles = {
  width: 'auto',
  transform: 'translate(43px, calc(-100% - 17px))',
  zIndex: '150',
};

const tooltipWarningContentStyles = {
  transform: 'translate(calc(-50% + 7px), calc(-100% - 7px))',
  zIndex: '150',
};

const initialTooltipContentStylesInner = {
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '15px',
  width: 'max-content',
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  rowGap: '10px',
  overflowY: 'auto',
};

export const WatchlistTopicsListItem = (props) => {
  const {
    watchlistId,
    asset,
    token,
    actions,
    activeWatchlistTopics,
    piwikEnabled,
  } = props;

  const assetItemClass = cx({
    assets_list_item: true,
    active: !asset.hidden,
    has_new: true,
  });
  const assetCheckbox = cx({
    assets_checkbox: true,
    active: !asset.hidden,
  });

  const { width } = useSizes();

  const tooltipContentStylesInner = useMemo(() => {
    let maxWidth;
    let maxHeight;
    if (width >= 1024) {
      maxWidth = 'calc(100vw - 126px)';
      maxHeight = '120px';
    } else if (width >= 768) {
      maxWidth = 'calc(50vw - 90px)';
      maxHeight = '200px';
    } else {
      maxWidth = 'calc(100vw - 120px)';
      maxHeight = '200px';
    }

    return {
      ...initialTooltipContentStylesInner,
      maxWidth,
      maxHeight,
    };
  }, [width]);

  let name;
  if (asset.logical_structure instanceof Object) {
    name = parseQueryLogicalStructure(asset.logical_structure, true);
  } else {
    ({ name } = asset.query ? queryItemWatchlistParser(asset.query) : asset);
  }

  const selectTopic = (e) => {
    if (e.target.classList.contains('fa-ellipsis')) return;

    if (piwikEnabled && !asset.hidden) {
      _paq.push(['trackEvent', 'WL page', 'Unselect this topic', name]);
    } else if (piwikEnabled && asset.hidden) {
      _paq.push(['trackEvent', 'WL page', 'Select this topic', name]);
    }

    if (token) {
      return actions.uncheckTopic(
        asset.query,
        asset.id,
        !asset.hidden,
        token,
        activeWatchlistTopics,
        watchlistId,
      );
    }
    return actions.uncheckGuestQuery(asset.id, !asset.hidden);
  };

  let type = asset.entity_type ? asset.entity_type : asset.groups[0].groupType;
  if (type === 'TopicClass') type = 'Topic class';

  return (
    <li
      className={`${assetItemClass} asset-item`}
      onClick={selectTopic}
    >
      {!asset.logical_structure?.populated && type !== 'Topic class' && (
        <div className={Styles.stories_warning}>
          <Tooltip
            icon={(
              <div className={Styles.stories_warning_icon_holder}>
                <FontAwesomeIcon icon={faExclamation} />
              </div>
            )}
            tooltipClassName={Styles.stories_warning_tooltip}
            renderOutside={width >= 1024}
            hideWithOverflow
            contentStyle={width >= 1024 ? tooltipWarningContentStyles : {}}
          >
            Stories for this topic are still being processed. Accuracy may vary.
          </Tooltip>
        </div>
      )}
      <div
        className={assetCheckbox}
      >
        <div className={Styles.checkbox_inner}>
          {!asset.hidden && <FontAwesomeIcon icon={faCheck} />}
        </div>
      </div>
      <Tooltip
        icon={(
          <div className={Styles.watchlist_topic_name_wrapper}>
            {name}
          </div>
        )}
        className={Styles.watchlist_topic_name}
        renderOutside
        rightAligned
        skipSmall
        hideWithOverflow
        contentStyle={tooltipContentStyles}
      >
        <div style={tooltipContentStylesInner}>
          {name}
        </div>
      </Tooltip>
      <div
        className={Styles.asset_menu}
        id={asset.id}
      >
        <WatchlistTopicsToolip
          topicId={asset.id}
          asset={asset}
          watchlistId={watchlistId}
          token={token}
          actions={actions}
          activeWatchlistTopics={activeWatchlistTopics}
          piwikEnabled={piwikEnabled}
          topicName={name}
        />
      </div>
    </li>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...watchlistActions, ...searchActions }, dispatch),
});

const mapStateToProps = (state) => ({
  activeWatchlist: state.watchlistReducer.activeWatchlist,
  activeWatchlistTopics: state.watchlistReducer.activeWatchlistTopics,
  storyFilters: state.storyFilters,
  token: state.watchlistReducer.userToken,
  stories: state.watchlistReducer.activeWatchlistStories,
  guestStories: state.searchReducers.stories,
});

export default withComponentName(
  connect(mapStateToProps, mapDispatchToProps)(WatchlistTopicsListItem),
);
